<div class="add-tag" [formGroup]="form">
  <div class="custom-dropdown border-radius-4 spacing-12 radius-top-right">
    <div class="d-flex align-items-center spacing-4 w-100 justify-content-between">
      <div class="d-flex flex-column spacing-8">
        <div class="d-flex align-items-start spacing-8">
          <app-datatypes
            [label]="'database'"
            [size]="'large'"
            [Type]="'string_text'"></app-datatypes>
          <h3 class="h3-bold primary-100">{{ filterSignal().name }}</h3>

          <app-badges
            class="dropdown"
            [withIcon]="false"
            [Type]="'white'"
            [IconType]="'chevron_down'"
            [counter]="false"
            [dividedText]="false"
            [close]="true"
            [onlyIcon]="false"
            [label]="selectedCondition.name"
            [ellipsis]="true"></app-badges>

          <app-dropdown
            class="dropdown-menu"
            [search]="false"
            [dropdownStatus]="false"
            [dropdownList]="true"
            [dropdown]="comparisonFiltersArraySignal()"
            (onClick)="onDropdownChange($event)"></app-dropdown>
        </div>
        <div class="d-flex align-items-start spacing-8">
          @if (
            filterSignal().join_condition_by === 'status' ||
            filterSignal().join_condition_by === 'payment_status'
          ) {
            <app-inputs
              class="w-100"
              formControlName="input1"
              [Label]="''"
              [name]="'input1'"
              [form]="form"
              [active]="false"
              [dropdown]="true"
              [stepCounter]="false"
              [options]="options"
              optionPlaceholder="select status"
              [prefix]="false"
              [suffix]="false"
              [prefixBadge]="{ icon: 'down_arrow', type: 'white', label: '%' }"
              [suffixBadge]="{
                icon: 'down_arrow',
                type: 'white',
                label: 'units',
              }"
              [warn]="getErrorMsg(form.get('input1'), 'input1') ? true : false"
              [state]="getErrorMsg(form.get('input1'), 'input1') ? 'warning' : 'default'"
              [error]="getErrorMsg(form.get('input1'), 'input1')">
            </app-inputs>
          }
          @if (
            selectedCondition.showInput &&
            filterSignal().join_condition_by !== 'date' &&
            filterSignal().join_condition_by !== 'status' &&
            filterSignal().join_condition_by !== 'payment_status'
          ) {
            <app-inputs
              class="w-100"
              formControlName="input1"
              [Label]="''"
              [name]="'input1'"
              [form]="form"
              [active]="false"
              [dropdown]="false"
              [stepCounter]="false"
              [placeholder]="'enter value'"
              (keyup.enter)="onEnterKeyPress()"
              [prefix]="false"
              [suffix]="false"
              [prefixBadge]="{ icon: 'down_arrow', type: 'white', label: '%' }"
              [suffixBadge]="{
                icon: 'down_arrow',
                type: 'white',
                label: 'units',
              }"
              [warn]="getErrorMsg(form.get('input1'), 'input1') ? true : false"
              [state]="getErrorMsg(form.get('input1'), 'input1') ? 'warning' : 'default'"
              [error]="getErrorMsg(form.get('input1'), 'input1')">
            </app-inputs>
            @if (selectedCondition.showInput && selectedCondition.multipleInputs) {
              <app-inputs
                class="w-100"
                formControlName="input2"
                [Label]="''"
                [name]="'input2'"
                [form]="form"
                [active]="false"
                [dropdown]="false"
                [stepCounter]="false"
                [placeholder]="'enter value'"
                (keyup.enter)="onEnterKeyPress()"
                [prefix]="false"
                [suffix]="false"
                [prefixBadge]="{
                  icon: 'down_arrow',
                  type: 'white',
                  label: '%',
                }"
                [suffixBadge]="{
                  icon: 'down_arrow',
                  type: 'white',
                  label: 'units',
                }"
                [warn]="getErrorMsg(form.get('input2'), 'input2') ? true : false"
                [state]="getErrorMsg(form.get('input2'), 'input2') ? 'warning' : 'default'"
                [error]="getErrorMsg(form.get('input2'), 'input2')">
              </app-inputs>
            }
          }
          <!-- @if (selectedCondition.showInput && filterSignal().join_condition_by == 'date') {
            <app-calendar
              formControlName="input1"
              [type]="'single_date'"
              [label]="''"
              [filter]="filter"
              (onInputChange)="getValue($event, filter)"
              [error]="false"
              class="price-dropdown w-100 dropdown-menu-lg-end"></app-calendar>
            @if (selectedCondition.showInput && selectedCondition.multipleInputs) {
              <app-calendar
                formControlName="input2"
                [type]="'single_date'"
                [label]="''"
                [filter]="filter"
                (onInputChange)="getValue($event, filter)"
                class="price-dropdown w-100 dropdown-menu-lg-end"></app-calendar>
            }
          } -->

          <app-buttons
            [active]="false"
            class="w-100"
            [disabled]="selectedCondition.showInput && form.invalid"
            [shortcutKey]="false"
            label="Apply filter"
            IconType="loader"
            size="large"
            [Type]="btnType"
            (btnClick)="onSave()"></app-buttons>
        </div>
      </div>
    </div>
  </div>
</div>
